import { render } from "./index.vue?vue&type=template&id=9a2415a4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=9a2415a4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9a2415a4"

export default script